module.exports = __webpack_public_path__ + "static/media/1012637.b715ab97.jpg";